import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'

const Error = styled.div`
position: relative;
width:100%;
height:calc(100vh - 50px);
h1 {
    position: absolute;
    width:100%;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    color: rgba(0, 0, 0, .3);
    font-size: 5em;
    text-align:center;
}
h1:before {
    content: attr(data-text);
    max-width:100%;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    position: absolute;
    overflow: hidden;
    white-space: nowrap;
    color: #fff;
    opacity:1;
    animation: error 1.5s linear infinite alternate;
}
@keyframes error {
    0% {
        opacity:0;
    }
}
@media screen and (max-width:768px){
    h1{
        font-size:2em;
    }
}
`

export default ({ data }) => {
    const history = useHistory()
    useEffect(() => {
        setTimeout(() => history.goBack(), 1500)
        return () => clearTimeout(() => history.goBack(), 2000)
    }, [history])
    return (
        <>
            <Error ><br /><br />
                <h1 data-text={data ? data + ' wait 2s' : 'Error...wait 2s'}>{data ? data + ' wait 2s' : 'Error...wait 2s'}</h1>
            </Error >
        </>
    )
}